module.exports = __webpack_public_path__ + "static/media/iqra4.bb13c43b.jpg";